var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 30,
    viewBox: "0 0 628 348"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "407 46.595 534.639 174 407 301.405 453.681 348 628 174 453.681 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,301.404983 L260.309746,174 L388,46.5950165 L341.243142,0 L213.395634,127.404983 L166.796029,174 L137.337112,203.35695 C125.387266,215.421113 107.308026,219.09616 91.5713583,212.659957 C75.8346911,206.223754 65.5586778,190.951578 65.5586778,174 C65.5586778,157.048422 75.8346911,141.776246 91.5713583,135.340043 C107.308026,128.90384 125.387266,132.578887 137.337112,144.64305 L151.909317,159.164815 L198.666175,112.569799 L184.09397,98.0480336 C153.262621,67.3014871 106.879638,58.0944242 66.5791953,74.7212474 C26.2787524,91.3480705 0,130.533311 0,174 C0,217.466689 26.2787524,256.651929 66.5791953,273.278753 C106.879638,289.905576 153.262621,280.698513 184.09397,249.951966 L213.552888,220.595017 L341.400396,348 L388,301.404983 Z"
  }))));
}

export default SvgLogo;